import script from "./SitesOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./SitesOverview.vue?vue&type=script&setup=true&lang=js"

import "./SitesOverview.vue?vue&type=style&index=0&id=38d114a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d114a1"]])

export default __exports__